import { baseConfig, useOidcStore } from "@scayla/core";

import { $t } from "@/i18n";

/**
 * Short-lived download URL of a stored file, or `undefined` when there is no session or the
 * backend returned no `signed-url` header. `generation` selects an older version of the file.
 */
export async function fetchSignedFileUrl(objectName: string, generation?: string): Promise<string | undefined> {
  const token = useOidcStore().state.value.token;
  if (!token) return undefined;

  const query = generation ? `?generation=${encodeURIComponent(generation)}` : "";
  const response = await fetch(
    `${baseConfig.scaylaApiUrl}/files/transfer/signed_url/${encodeURIComponent(objectName)}${query}`,
    { headers: { authorization: `Bearer ${token}` }, method: "HEAD" },
  );

  return response.headers.get("signed-url") ?? undefined;
}

/** Like `fetchSignedFileUrl`, but throws the user-facing download error instead of returning `undefined`. */
export async function fetchSignedFileUrlOrThrow(objectName: string, generation?: string): Promise<string> {
  const signedUrl = await fetchSignedFileUrl(objectName, generation);
  if (!signedUrl) throw new Error($t("common.message.downloadFileError"));
  return signedUrl;
}
